import React, { useState } from 'react';
import { useApp } from '../context/AppContext';

export default function ArtistProfile() {
  const { currentUser, artists, cones, getArtistStats, logout, checkIn, checkOut } = useApp();
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  const artist = artists.find(a => a.id === currentUser.id);
  if (!artist) return <div style={{ padding: '2rem', color: '#888' }}>Artist not found.</div>;

  const stats = getArtistStats(artist.id, dateFrom || undefined, dateTo || undefined);
  const today = new Date().toISOString().split('T')[0];
  const todayStats = getArtistStats(artist.id, today, today);

  const getWorkingTime = () => {
    if (!artist.active || !artist.checkInTime) return null;
    const mins = Math.round((Date.now() - new Date(artist.checkInTime)) / 60000);
    const h = Math.floor(mins / 60), m = mins % 60;
    return `${h}h ${m}m`;
  };

  const totalMins = artist.totalWorkMinutes || 0;
  const totalHours = Math.floor(totalMins / 60);
  const wt = getWorkingTime();

  const inp = { padding: '8px 11px', borderRadius: 3, border: '1px solid #ddd', fontSize: 13, outline: 'none', background: '#fafafa', color: '#1c1c1c' };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f4f2', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}>

      <div style={{ background: '#1c1c1c', padding: '0 1rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 52 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 20, height: 20, border: '2px solid #c9a96e', borderRadius: 2, flexShrink: 0 }} />
          <span style={{ color: '#fff', fontWeight: 700, fontSize: 15, fontFamily: 'Georgia, serif' }}>Mehendi by Marjana</span>
        </div>
        <button onClick={logout} style={{ padding: '5px 12px', borderRadius: 3, background: 'transparent', color: '#888', border: '1px solid #444', cursor: 'pointer', fontSize: 12 }}>Sign out</button>
      </div>

      <div style={{ padding: '1rem', maxWidth: 860, margin: '0 auto' }}>

        {/* Profile header */}
        <div style={{ background: '#fff', borderRadius: 3, padding: '1.2rem', border: '1px solid #e8e8e8', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
          <div style={{ width: 52, height: 52, borderRadius: '50%', background: artist.color || '#c9a96e', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 22, flexShrink: 0 }}>{artist.name[0]}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <h1 style={{ margin: '0 0 3px', color: '#1c1c1c', fontSize: 18, fontWeight: 700, fontFamily: 'Georgia, serif' }}>{artist.name}</h1>
            <div style={{ fontSize: 13, color: '#888' }}>Mehendi Artist &nbsp;·&nbsp; {artist.commission}% commission</div>
          </div>
          <div style={{ display: 'flex', gap: 6 }}>
            <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 8px', borderRadius: 2, background: artist.present ? '#f0f7f0' : '#f5f5f5', color: artist.present ? '#2e6b2e' : '#bbb', border: `1px solid ${artist.present ? '#d0e8d0' : '#ebebeb'}` }}>{artist.present ? 'Present' : 'Absent'}</span>
            <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 8px', borderRadius: 2, background: artist.active ? '#f9f7f3' : '#f5f5f5', color: artist.active ? '#c9a96e' : '#bbb', border: `1px solid ${artist.active ? '#ebe5d8' : '#ebebeb'}` }}>{artist.active ? 'Active' : 'Idle'}</span>
          </div>
        </div>

        {/* Session banner */}
        {artist.active && wt && (
          <div style={{ background: '#fff', border: '1px solid #ebe5d8', borderLeft: '3px solid #c9a96e', borderRadius: 3, padding: '12px 14px', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 11, color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 2 }}>Current session</div>
              <div style={{ fontSize: 18, fontWeight: 700, color: '#1c1c1c' }}>{wt}</div>
            </div>
            <button onClick={() => checkOut(artist.id)} style={{ padding: '8px 14px', borderRadius: 3, background: '#1c1c1c', border: 'none', color: '#fff', cursor: 'pointer', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Finish Work</button>
          </div>
        )}

        {artist.present && !artist.active && (
          <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: 3, padding: '12px 14px', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
            <div style={{ fontSize: 13, color: '#888', flex: 1 }}>You are marked present. Start your session when ready.</div>
            <button onClick={() => checkIn(artist.id)} style={{ padding: '8px 14px', borderRadius: 3, background: '#c9a96e', border: 'none', color: '#fff', cursor: 'pointer', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Start Work</button>
          </div>
        )}

        {/* Today stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: 10, marginBottom: '1.5rem' }}>
          {[
            { label: "Today's jobs", value: todayStats.jobCount },
            { label: "Today's revenue", value: `৳${todayStats.totalRevenue.toFixed(0)}` },
            { label: "Today's earning", value: `৳${todayStats.totalEarning.toFixed(0)}`, accent: true },
            { label: 'Total hours', value: `${totalHours}h` },
          ].map(s => (
            <div key={s.label} style={{ background: '#fff', borderRadius: 3, padding: '1rem', border: s.accent ? '1px solid #ebe5d8' : '1px solid #e8e8e8' }}>
              <div style={{ fontSize: 11, color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>{s.label}</div>
              <div style={{ fontSize: 20, fontWeight: 700, color: s.accent ? '#c9a96e' : '#1c1c1c' }}>{s.value}</div>
            </div>
          ))}
        </div>

        {/* Organic cone summary */}
        {stats.organicConesUsed > 0 && (
          <div style={{ background: '#f0f5ee', border: '1px solid #c8ddc4', borderRadius: 3, padding: '12px 14px', marginBottom: '1rem' }}>
            <div style={{ fontSize: 11, color: '#4a6741', textTransform: 'uppercase', letterSpacing: '0.04em', fontWeight: 600, marginBottom: 2 }}>Organic cones used</div>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#1c1c1c' }}>{stats.organicConesUsed} cones &mdash; ৳{stats.organicConeRevenue.toFixed(0)} collected by studio</div>
          </div>
        )}

        {/* Date filter */}
        <div style={{ background: '#fff', borderRadius: 3, padding: '1rem', border: '1px solid #e8e8e8', marginBottom: '1rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 12, color: '#888', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Filter</span>
            <input type="date" style={inp} value={dateFrom} onChange={e => setDateFrom(e.target.value)} />
            <span style={{ color: '#ccc', fontSize: 12 }}>to</span>
            <input type="date" style={inp} value={dateTo} onChange={e => setDateTo(e.target.value)} />
            {(dateFrom || dateTo) && <button onClick={() => { setDateFrom(''); setDateTo(''); }} style={{ padding: '8px 12px', borderRadius: 3, background: '#fff', border: '1px solid #ddd', color: '#555', cursor: 'pointer', fontSize: 12 }}>Clear</button>}
            <div style={{ marginLeft: 'auto', display: 'flex', gap: 16, flexWrap: 'wrap' }}>
              <div style={{ textAlign: 'right' }}><div style={{ fontSize: 11, color: '#aaa' }}>Jobs</div><div style={{ fontWeight: 700, color: '#1c1c1c' }}>{stats.jobCount}</div></div>
              <div style={{ textAlign: 'right' }}><div style={{ fontSize: 11, color: '#aaa' }}>Revenue</div><div style={{ fontWeight: 700, color: '#1c1c1c' }}>৳{stats.totalRevenue.toFixed(0)}</div></div>
              <div style={{ textAlign: 'right' }}><div style={{ fontSize: 11, color: '#aaa' }}>Your earnings</div><div style={{ fontWeight: 700, color: '#c9a96e', fontSize: 16 }}>৳{stats.totalEarning.toFixed(0)}</div></div>
            </div>
          </div>
        </div>

        {/* Job history */}
        <div style={{ background: '#fff', borderRadius: 3, border: '1px solid #e8e8e8', overflow: 'hidden' }}>
          <div style={{ padding: '12px 14px', borderBottom: '1px solid #f0f0f0' }}>
            <span style={{ fontSize: 12, fontWeight: 700, color: '#1c1c1c', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Job History</span>
          </div>
          <div style={{ maxHeight: 420, overflowY: 'auto' }}>
            {[...stats.jobs].reverse().map((j, i) => (
              <div key={j.id} style={{ padding: '11px 14px', borderBottom: '1px solid #f5f5f5', display: 'flex', alignItems: 'center', gap: 12, background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#1c1c1c' }}>৳{j.amount}{j.note && <span style={{ color: '#aaa', fontWeight: 400 }}> &nbsp;·&nbsp; {j.note}</span>}</div>
                  <div style={{ fontSize: 11, color: '#bbb' }}>{j.date}</div>
                </div>
                <div style={{ textAlign: 'right', flexShrink: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: '#c9a96e' }}>৳{j.artistEarning.toFixed(0)}</div>
                  <div style={{ fontSize: 11, color: '#ccc' }}>{j.commission}%</div>
                </div>
              </div>
            ))}
            {stats.jobs.length === 0 && <div style={{ padding: '2.5rem', textAlign: 'center', color: '#ccc', fontSize: 13 }}>No job records in selected range.</div>}
          </div>
        </div>

      </div>
    </div>
  );
}
